import styled from 'styled-components';

export default styled.div`
  display: flex;
  align-items: center;

  input {
    appearance: none;
    width: 20px;
    height: 20px;
    border: solid 1px #cccccc;
    margin-right: 8px;
    position: relative;
    outline: none;
    cursor: pointer;
    transition: all 200ms ease-in-out;
  }

  input:checked::before {
    content: '';
    width: 14px;
    height: 14px;
    background-color: ${(props) => props.theme.colors.secondary};
    position: absolute;
    top: 2px;
    left: 2px;
  }

  input:disabled::before {
    background-color: ${(props) => props.theme.colors.greyDark};
  }

  label {
    font-size: 14px;
  }

  input:disabled + label {
    color: ${(props) => props.theme.colors.greyDark};
  }
`;
